// All configuration comes from REACT_APP_* environment variables (see .env.example).
// CRA inlines each variable at build time, so every one must be referenced literally.
const required = (name: string, value: string | undefined): string => {
  if (!value) throw new Error(`Missing required environment variable ${name}`);
  return value;
};

export const API_URL = required('REACT_APP_REQUEST_URL', process.env.REACT_APP_REQUEST_URL);
export const API_URL_NEW = required('REACT_APP_REQUEST_URL_NEW', process.env.REACT_APP_REQUEST_URL_NEW);
export const API_URL_INTEGRATION = process.env.REACT_APP_REQUEST_URL;
export const AAV_LINK = process.env.REACT_APP_AAV_LINK;
export const API_URL_STORY = required('REACT_APP_STORY_LINK', process.env.REACT_APP_STORY_LINK);

export const ORDER_API_URL = required('REACT_APP_ORDER_API_URL', process.env.REACT_APP_ORDER_API_URL);
export const PRINTFULL_ID = required('REACT_APP_PRINTFULL_ID', process.env.REACT_APP_PRINTFULL_ID);
export const FREEPRINTS_ID = required('REACT_APP_FREEPRINTS_ID', process.env.REACT_APP_FREEPRINTS_ID);
export const DRAWPILLOWS_ID = required('REACT_APP_DRAWPILLOWS_ID', process.env.REACT_APP_DRAWPILLOWS_ID);
export const INK_ID = required('REACT_APP_INK_ID', process.env.REACT_APP_INK_ID);
export const TEST_ID = required('REACT_APP_TEST_ID', process.env.REACT_APP_TEST_ID);
export const PRINTIFY_ID = required('REACT_APP_PRINTIFY_ID', process.env.REACT_APP_PRINTIFY_ID);
export const PRINTIFY_TEST_ID = required('REACT_APP_PRINTIFY_TEST_ID', process.env.REACT_APP_PRINTIFY_TEST_ID);

export const EXTRA_FEATURES_CLIENT_IDS = [PRINTIFY_TEST_ID, PRINTIFY_ID, TEST_ID];
